import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { TextField, MenuItem } from "@mui/material";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { useNavigate, useLocation } from "react-router-dom";
import DataGrid from "./DataGrid";
import ApiOrderService from "../../../core/api/api.ordersService";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const BasketReport = () => {
  let location = useLocation();
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  // const [fromCreatedDate, setfromCreatedDate] = useState();
  // const [toCreatedDate, settoCreatedDate] = useState();
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
          ? _.toNumber(pageNumberFromUrl1)
          : getValues("pageNumber");
        const apiData = await ApiOrderService.BasketReport({
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          toCreatedDate: searchParams.get("toCreatedDate"),
          typeShowResult: searchParams.get("typeShowResult"),
          globalSearch: searchParams.get("globalSearch"),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
        });
        if (apiData && apiData?.data && apiData?.data.length > 0)
          apiData.data.forEach((item) => {
            item.profit =
              item.paymentAmount -
              item.receiveAmount -
              item.payToWarantyAmount +
              item.receiveOfWarantyAmount -
              item.commisonAmount;
            item.paymentAmountUser = item.paymentAmount - item.receiveAmount;
            item.paymentAmountWaranty = item.payToWarantyAmount - item.receiveOfWarantyAmount;
          });
        setListData(apiData);
        setValue("totalCount", apiData.totalCount);
        const formInputs = [
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "typeShowResult", type: "text" },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    data.pageNumber = getValues("pageNumber");
    if (data.fromCreatedDate !== null && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate !== null && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiOrderService.BasketReport(data);
    if (apiData && apiData?.data && apiData?.data?.length > 0)
      apiData.data.forEach((item) => {
        item.profit =
          item.paymentAmount -
          item.receiveAmount -
          item.payToWarantyAmount +
          item.receiveOfWarantyAmount -
          item.commisonAmount;
        item.paymentAmountUser = item.paymentAmount - item.receiveAmount;
        item.paymentAmountWaranty = item.payToWarantyAmount - item.receiveOfWarantyAmount;
      });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/basketReport?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">لیست سفارشات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست سفارشات</span>
          </h3>
          <div className="card-toolbar">
            {/* <Link className="btn btn-success" variant="success"
                            key={0}
                            to={{
                                pathname: `/agencyTransaction/0`,
                                state: { id: 0 }
                            }}
                        >
                            <AddCircle className='mr-1' />
                            افزودن سفارش
                        </Link> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0 ">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body className="pt-0">
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-4"
                                  value={value}
                                  placeholder=" از تاریخ ایجاد"
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      // Set the value of toCreatedDate to the same as toCreatedDate
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-4"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ ایجاد"
                                />
                              )}
                            />
                          </Col>

                          {/* <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="typeShowResult"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  select
                                  label="انتخاب وضعیت"
                                  className="mt-4"
                                  variant="outlined"
                                  margin="normal"
                                  size="small"
                                  value={value || ""}
                                  onChange={onChange}
                                >
                                  <MenuItem key={99} value={undefined}>
                                    {" "}
                                    --{" "}
                                  </MenuItem>
                                  <MenuItem key={1} value={"basket"}>
                                    {" "}
                                    بر اساس سفارش{" "}
                                  </MenuItem>
                                  <MenuItem key={2} value={"basketItem"}>
                                    {" "}
                                    بر اساس تفریح{" "}
                                  </MenuItem>
                                  <MenuItem key={3} value={"basketItemPerson"}>
                                    {" "}
                                    بر اساس بلیط{" "}
                                  </MenuItem>
                                </TextField>
                              )}
                            />
                          </Col> */}
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-2 pt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default BasketReport;
